import React from "react";
import { Box, Container, Stack } from "@mui/material";
import {
  DeleteOutlined,
  EditOutlined,
  InfoOutlined,
  PhotoLibraryOutlined,
  RestoreOutlined,
} from "@mui/icons-material";
import EditArchive from "../components/EditArchive";
import ArchivesTable from "../tables/ArchivesTable";
import LoadingDialog from "../components/LoadingDialog";
import HeaderArchives from "../components/HeaderArchives";
import ObjectCardGrid from "../components/ObjectCardGrid";
import ViewToggle, { useViewMode } from "../components/ViewToggle";
import { tokens } from "../theme/theme";

const ArchivesPage = ({
  release,
  items,
  deleteItem,
  openArchiveInfo,
  handleOpenPhotos,
  returnItem,
  loadNextArchives,
  hasMore,
  openViewPage,
  isEditItem,
  editArchiveItem,
  onCloseEditDialog,
  regionSearchTerms,
  streetSearchTerms,
  onEditItem,
  showLoading,
  handleEditItem,
  queryObjects,
  s3Client,
  albumPhotos,
  albumLoading,
  onReorderAlbum,
  onDeleteAlbumPhoto,
}) => {
  // Its own remembered choice: the archive is browsed differently from the
  // live list, so inheriting that view would be a guess.
  const [mode, setMode] = useViewMode("archives", "table");

  const actions = [
    {
      key: "info",
      label: "Додаткова інформація",
      icon: <InfoOutlined sx={{ fontSize: 19 }} />,
      onClick: (item) => openArchiveInfo(item.id),
    },
    {
      key: "photos",
      label: "Фото",
      icon: <PhotoLibraryOutlined sx={{ fontSize: 19 }} />,
      onClick: (item) => handleOpenPhotos(item.id),
    },
    {
      key: "edit",
      label: "Редагувати",
      icon: <EditOutlined sx={{ fontSize: 19 }} />,
      onClick: (item) => handleEditItem(item.id),
    },
    {
      key: "return",
      label: "Повернути в базу",
      icon: <RestoreOutlined sx={{ fontSize: 19 }} />,
      color: tokens.green600,
      onClick: (item) => returnItem(item.id),
    },
    {
      key: "delete",
      label: "Видалити назавжди",
      icon: <DeleteOutlined sx={{ fontSize: 19 }} />,
      color: tokens.red600,
      onClick: (item) => deleteItem(item.id),
    },
  ];

  return (
    <div>
      <HeaderArchives
        queryObjects={queryObjects}
        regionSearchTerms={regionSearchTerms}
        streetSearchTerms={streetSearchTerms}
      />
      {showLoading && <LoadingDialog />}
      {items.length > 0 ? (
        <Box>
          {/* Same inset as ArchivesTable's `mx`, so the toggle lines up with
              the table and the card grid alike. */}
          <Container maxWidth={false} sx={{ px: { xs: 1, md: 2 } }}>
            {/* 12/12 around the toggle — see RealEstateObjects.js. */}
            <Stack direction="row" justifyContent="flex-end" sx={{ pt: 0, pb: 1.5 }}>
              <ViewToggle mode={mode} onChange={setMode} />
            </Stack>
          </Container>

          {mode === "cards" ? (
            <ObjectCardGrid
              items={items}
              s3Client={s3Client}
              actions={actions}
              onOpen={(item) => openViewPage({ row: item })}
              loadNext={loadNextArchives}
              hasMore={hasMore}
            />
          ) : (
            <ArchivesTable
              items={items}
              deleteItem={deleteItem}
              openArchiveInfo={openArchiveInfo}
              handleOpenPhotos={handleOpenPhotos}
              returnItem={returnItem}
              loadNextObjects={loadNextArchives}
              openViewPage={openViewPage}
              handleEditItem={handleEditItem}
            />
          )}
        </Box>
      ) : (
        <div
          id="No_clients"
          style={{
            alignContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          Немає архівів
        </div>
      )}
      {isEditItem && (
        <EditArchive
          onEditItem={onEditItem}
          onCloseDialog={onCloseEditDialog}
          regionSearchTerms={regionSearchTerms}
          streetSearchTerms={streetSearchTerms}
          item={editArchiveItem}
          albumPhotos={albumPhotos}
          albumLoading={albumLoading}
          onReorderAlbum={onReorderAlbum}
          onDeleteAlbumPhoto={onDeleteAlbumPhoto}
        />
      )}
    </div>
  );
};

export default ArchivesPage;
